<template>
    <div :class="['alert', 'alert-custom', `alert-light-${validVariant}`, 'st-alert']" :role="role">
        <div class="alert-icon">
            <i :class="icon || defaultIcon"></i>
        </div>
        <div class="alert-text">
            <slot>{{ text }}</slot>
        </div>
        <div v-if="$slots.action" class="st-alert-action">
            <slot name="action"></slot>
        </div>
    </div>
</template>

<script>
const ICONS = {
    info: 'fas fa-info-circle',
    warning: 'fas fa-exclamation-triangle',
    danger: 'fas fa-exclamation-circle',
    success: 'fas fa-check-circle',
};

// The inline notice of the application pages: tinted background, an icon, the text, room for one button.
export default {
    name: 'StAlert',
    props: {
        variant: {
            type: String,
            default: 'info',
        },
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        // 'alert' is read out at once, so it is for what interrupts; a notice that is part of the page is a 'status'
        role: {
            type: String,
            default: 'status',
        },
    },
    computed: {
        validVariant() {
            return ICONS[this.variant] ? this.variant : 'info';
        },
        defaultIcon() {
            return ICONS[this.validVariant];
        },
    },
};
</script>

<style scoped>
.st-alert {
    align-items: center;
}

.st-alert-action {
    flex: 0 0 auto;
    margin-left: 1rem;
}
</style>
